import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { AppSettings } from '@app/common/app-setting';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders } from '@angular/common/http';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';
import { VehicleDetailModel } from '@app/models/VehicleDetailModel';

@Injectable()
export class VehicleDetailsEndpoint extends AutharizedEndPointService{
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getVehicleDetailsUrl: string = '/api/usermanagement/GetVehicleDetails';
    private readonly _addUpdateMapVehicleDetailsUrl: string = 'api/usermanagement/AddOrEditVehicle';
    private readonly  _getMappedVehicleUrl: string = 'api/CardOperation/MapVehcile/';
    private readonly  _getUnMappedVehicleUrl:string='api/CardOperation/UnMapVehcile/';
    
    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    getVehicleDetails() {
        return this.http1.get<VehicleDetailModel>
            (this.getUrl(this._getVehicleDetailsUrl), this.AddAuthToken());

    }
    
    updateVehicleDetails(vehicledetail:VehicleDetailModel) {
        return this.http1.post(this.getUrl(this._addUpdateMapVehicleDetailsUrl), vehicledetail , this.AddAuthToken());

    }

    addVehicleDetails(vehicledetails:VehicleDetailModel) {
        return this.http1.post(this.getUrl(this._addUpdateMapVehicleDetailsUrl), vehicledetails, this.AddAuthToken());

    }

    mappedVehicle(mappingId:string,cardID:number)
    {
        return this.http1.get(this.getUrl(this._getMappedVehicleUrl) + mappingId +'/'+cardID, this.AddAuthToken());
    }

    unMappedVehicle(mappingId:string,cardID:number)
    {
        return this.http1.get(this.getUrl(this._getUnMappedVehicleUrl) + mappingId +'/'+cardID, this.AddAuthToken());
    }

}


// WEBPACK FOOTER //
// ./src/app/services/vehicleDetails/vehicledetails-endpoint.service.ts